import { render } from "./TimeSelector.vue?vue&type=template&id=02b0aef2&scoped=true"
import script from "./TimeSelector.vue?vue&type=script&lang=js"
export * from "./TimeSelector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b0aef2"]])

export default __exports__